import { createFileRoute } from '@tanstack/react-router';
import { GenericPageHeader } from '@/components/layout/page-header';
import { useHasPermission } from '@/hooks/usePermissions';
import { MyStaffingPostingsPage } from '@/pages/staffing/MyStaffingPostingsPage';
import { ShieldAlert } from 'lucide-react';
import { z } from 'zod';
import { useLingui, Trans } from '@lingui/react/macro';

const searchSchema = z.object({
	page: z.number().optional(),
	limit: z.number().optional(),
	search: z.string().optional(),
	status: z.enum(['ACTIVE', 'DRAFT', 'CLOSED', 'EXPIRED']).optional(),
	type: z.enum(['AVAILABLE', 'NEEDED']).optional(),
});

function MyStaffingPostingsRoute() {
	const { t } = useLingui();
	const canManagePostings = useHasPermission('staffing.managePostings');

	if (!canManagePostings) {
		return (
			<div className="flex flex-col h-full">
				<GenericPageHeader title={t`My postings`} />
				<div className="flex flex-1 items-center justify-center">
					<div className="space-y-2 text-center">
						<ShieldAlert className="mx-auto size-10 text-muted-foreground" />
						<p className="text-sm font-medium text-foreground">
							<Trans>Access Denied</Trans>
						</p>
						<p className="text-xs text-muted-foreground">
							<Trans>Postings management is only available to administrators.</Trans>
						</p>
					</div>
				</div>
			</div>
		);
	}

	return <MyStaffingPostingsPage />;
}

export const Route = createFileRoute('/_authenticated/_app/staffing/my-postings')({
	validateSearch: searchSchema,
	component: MyStaffingPostingsRoute,
});
